module.exports = __webpack_public_path__ + "img/icon-plus.a1aac95c.png";